import http from './api'

const url = '/admin_data/instance_settings'

export const httpGetInstanceSettings = () => {
  return http({
    url: `${url}/`,
    method: 'GET',
  })
}
